import Vue from "vue";

const Capitalize = Vue.filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
});

const CapitalizeCamelCase = Vue.filter('capitalizeCamelCase', function (value) {
  return typeof value === 'string' ? `${value.charAt(0).toUpperCase()}${value.slice(1)}` : value
});

export {
  Capitalize,
  CapitalizeCamelCase
};
